import React from 'react';
import styled from 'styled-components';
import bg_layer_1 from './bg-layer-1.png';
import ellipse_bg from './ellipse.svg';

const Container = styled.div`
  height: 100vh;
  background: #FFF;
  position: fixed;
  inset: 0;
  .bg-layer-1-container {
    position: relative;
    background: url(${bg_layer_1}) lightgray 50% / cover no-repeat;
  }
  .bg-layer-1 {
    width: 100%;
    height: auto;
  }

  .bg-overlay-color {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(200.33% 141.42% at 100% 0%, #022127 0%, #0C2F35 100%);
    opacity: 0.8;
  }

  .ellipse-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
`;
const OverlayBG = () => {
  return (
    <Container>
      <div className='bg-layer-1-container'>
        <img src={bg_layer_1} alt="bg_layer_1" className='bg-layer-1' />
        <div className="bg-overlay-color"></div>
      </div>
      <img src={ellipse_bg} alt="ellipse_bg" className="ellipse-bg" />
    </Container>
  );
};

export default OverlayBG;
